export default "__VITE_ASSET__DQh_ifUP__"